export const FIND_PROCESS_STATEMENT_QUESTIONS_FAILURE = 'FIND_PROCESS_STATEMENT_QUESTIONS_FAILURE';

export const findProcessStatementQuestionsFailure = error => ({
    type: FIND_PROCESS_STATEMENT_QUESTIONS_FAILURE,
    payload: error,
    error: true,
});
